// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap"); */
html,
body,
#root,

  .app { 
  height: 100%;
  width: 100%;
  align-items: center;
  font-family: 'Poppins', sans-serif;
  height:"webkit-fill-available";
} 
input:-webkit-autofill{
  -webkit-background-clip: text;
}

/* ::-webkit-scrollbar {
  width: 100%;
} */

/* Track */
::-webkit-scrollbar-track {
    background: #8691d1;
}
 

/* Handle */
::-webkit-scrollbar-thumb {
   background: #21295c; 
}

/* Handle on Hover */
::-webkit-scrollbar-track:hover {
   background: #21295c; 
}
.site-form-item-icon{
   margin-left: 100px;
    margin-top: 220px;
    width: 70%; 
    font-size:20px;
    font-weight: 100;
    margin-bottom: -10%;
}
.login-form-button {
  width: 28%;
  background: #5fbb46;
  color: #eee6e6;
  border: 1px solid #5fbb46;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  transition: background-color 0.3s ease;
  
}

.login-form-button:hover {
   background-color: #1ddb1d; 
 
}
.login-form-button1:hover {
  background-color: #048df0; 

}

.login-form-button1 {
  width: 35%;
  background: #43adf7;
  color: #eee6e6;
   border: 1px solid #43adf7; 
  border-radius: 6px; 
  font-size: 14px;
  font-weight: 400;
  transition: background-color 0.3s ease;
  
}
.btn-log:hover{  
  color: #0b76f0;
}
.input{
  align-items: left;
  margin-left: 38px;
   color: dimgray; 
}
.login-form{
  margin-right: 10px;
}
  .image{
    max-width: 60%;
  }
.for-remember{
  color: rgb(15, 14, 14);
}

.btn-log{
  color: #07c4f3;
}
.small {
  font-size: small;
}
.small1 {
  font-size: small;
  text-align: center;
}

.custom-checkbox input[type="checkbox"]:checked + .MuiSvgIcon-root {
  background-color: #07c4f3;
}


.error-container {
  text-align: center;
  font-size: 120px;
  font-weight: 800;
  margin: 20px 15px;
}

.error-container > span {
  display: inline-block;
  line-height: 0.7;
  position: relative;
  color: #FFB485;
  vertical-align: middle;
  font-size: 80px; 
}
.error-container > span:nth-of-type(1) {
  color: #D1F2A5;
  animation: colordancing 4s infinite;
}
.error-container > span:nth-of-type(2) {
  color: #D1F2A5;
  animation: colordancing1 4s infinite;
}

.error-container > span:nth-of-type(3) {
  color: #F56991;
  animation: colordancing2 4s infinite;
}

.error-container > span.zero:before {
  transform: rotate(45deg);
}

.screen-reader-text {
  position: absolute;
  top: -9999em;
  left: -9999em;
}


@keyframes shadowsdancing {
  0% {
    box-shadow: inset 30px 0 0 rgba(209, 242, 165, 0.4),
				inset 0 30px 0 rgba(239, 250, 180, 0.4),
				inset -30px 0 0 rgba(255, 196, 140, 0.4),	
				inset 0 -30px 0 rgba(245, 105, 145, 0.4);
  }
  25% {
    box-shadow: inset 30px 0 0 rgba(245, 105, 145, 0.4),
				inset 0 30px 0 rgba(209, 242, 165, 0.4),
				inset -30px 0 0 rgba(239, 250, 180, 0.4),	
				inset 0 -30px 0 rgba(255, 196, 140, 0.4);
  }
  50% {
     box-shadow: inset 30px 0 0 rgba(255, 196, 140, 0.4),
				inset 0 30px 0 rgba(245, 105, 145, 0.4),
				inset -30px 0 0 rgba(209, 242, 165, 0.4),	
				inset 0 -30px 0 rgba(239, 250, 180, 0.4);
  }
  75% {
   box-shadow: inset 30px 0 0 rgba(239, 250, 180, 0.4),
				inset 0 30px 0 rgba(255, 196, 140, 0.4),
				inset -30px 0 0 rgba(245, 105, 145, 0.4),	
				inset 0 -30px 0 rgba(209, 242, 165, 0.4);
  }
  100% {
    box-shadow: inset 30px 0 0 rgba(209, 242, 165, 0.4),
				inset 0 30px 0 rgba(239, 250, 180, 0.4),
				inset -30px 0 0 rgba(255, 196, 140, 0.4),	
				inset 0 -30px 0 rgba(245, 105, 145, 0.4);
  }
}
@keyframes colordancing {
  0% {
    color: #0cd7e6;
  }
  25% {
    color: #F56991;
  }
  50% {
    color: #FFC48C;
  }
  75% {
    color: #EFFAB4;
  }
  100% {
    color: #09e3f3;
  }
}
@keyframes colordancing2 {
  0% {
    color: #FFC48C;
  }
  25% {
    color: #EFFAB4;
  }
  50% {
    color: #09dfee;
  }
  75% {
    color: #F56991;
  }
  100% {
    color: #FFC48C;
  }
}
@keyframes colordancing1 {
  0% {
    color: #FFC48C;
  }
  25% {
    color: #EFFAB4;
  }
  50% {
    color: #09dfee;
  }
  75% {
    color: #F56991;
  }
  100% {
    color: #FFC48C;
  }
}

* {
    box-sizing: border-box;
}
body {
  background-color: #416475;
  margin-bottom: 50px;
}
html, button, input, select, textarea {
    color: #6c787e;
}
h1 {
  text-align: center;
  margin: 30px 15px;
}
.zoom-area { 
  max-width: 490px;
  margin: 30px auto 30px;
  font-size: 19px;
  text-align: center;
}
.link-container {
  text-align: center;
}
a.more-link {
  text-transform: uppercase;
  font-size: 13px;
    background-color: #92a4ad;
    padding: 10px 15px;
    border-radius: 0;
    color: #416475;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
  margin-top: 50px;
  letter-spacing: 1px;
}

@media only screen and (max-width: 1024px) {
  
  .error-container{
    display: block;
  }
  .my-grid-class{
    display: block;
    position: static;
    
  }
}
@media only screen and (min-width: 1025px) {
  
  .error-container {
    display: none;
  }
  .Desktop-feature{
    display: none;
  }
}
*:not(input) {
  -webkit-user-select: none;
          user-select: none;
}

.my-Box2 {
  border: none;
  padding: 5px;
  margin-bottom: 200%;
  font: 24px/36px sans-serif;
  overflow-y: scroll;

  /* Scrollbar styles */
  scrollbar-width: thin;
  scrollbar-color: rgb(49, 49, 48) rgb(79, 80, 78);

  /* Track styles */
  &::-webkit-scrollbar {
    width: 10px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgb(235, 238, 231);
  }

  /* Thumb styles */
  &::-webkit-scrollbar-thumb {
    background-color: rgb(134, 134, 128);
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #bdc5bd;
  }
}.pagination li button {
  color: #0985dd;
}








`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,iGAAiG;AAEjG;;;;;EAKE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH,UAAU;AACV;IACI,mBAAmB;AACvB;;;AAGA,WAAW;AACX;GACG,mBAAmB;AACtB;;AAEA,oBAAoB;AACpB;GACG,mBAAmB;AACtB;AACA;GACG,kBAAkB;IACjB,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;;AAExC;;AAEA;GACG,yBAAyB;;AAE5B;AACA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;GACb,yBAAyB;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;;AAExC;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;GAChB,cAAc;AACjB;AACA;EACE,kBAAkB;AACpB;EACE;IACE,cAAc;EAChB;AACF;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EAGE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE;IACE;;;4CAGwC;EAC1C;EACA;IACE;;;4CAGwC;EAC1C;EACA;KACG;;;4CAGuC;EAC1C;EACA;GACC;;;4CAGyC;EAC1C;EACA;IACE;;;4CAGwC;EAC1C;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;IAGI,sBAAsB;AAC1B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;IACI,cAAc;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,gBAAgB;;EAElB;AACF;AACA;;EAEE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;;EAElB,qBAAqB;EACrB,qBAAqB;EACrB,gDAAgD;;EAEhD,iBAAiB;EACjB;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,oCAAoC;EACtC;;EAEA,iBAAiB;EACjB;IACE,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;EAC3B;AACF,CAAC;EACC,cAAc;AAChB","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap\"); */\n@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap');\nhtml,\nbody,\n#root,\n\n  .app { \n  height: 100%;\n  width: 100%;\n  align-items: center;\n  font-family: 'Poppins', sans-serif;\n  height:\"webkit-fill-available\";\n} \ninput:-webkit-autofill{\n  -webkit-background-clip: text;\n}\n\n/* ::-webkit-scrollbar {\n  width: 100%;\n} */\n\n/* Track */\n::-webkit-scrollbar-track {\n    background: #8691d1;\n}\n \n\n/* Handle */\n::-webkit-scrollbar-thumb {\n   background: #21295c; \n}\n\n/* Handle on Hover */\n::-webkit-scrollbar-track:hover {\n   background: #21295c; \n}\n.site-form-item-icon{\n   margin-left: 100px;\n    margin-top: 220px;\n    width: 70%; \n    font-size:20px;\n    font-weight: 100;\n    margin-bottom: -10%;\n}\n.login-form-button {\n  width: 28%;\n  background: #5fbb46;\n  color: #eee6e6;\n  border: 1px solid #5fbb46;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 400;\n  transition: background-color 0.3s ease;\n  \n}\n\n.login-form-button:hover {\n   background-color: #1ddb1d; \n \n}\n.login-form-button1:hover {\n  background-color: #048df0; \n\n}\n\n.login-form-button1 {\n  width: 35%;\n  background: #43adf7;\n  color: #eee6e6;\n   border: 1px solid #43adf7; \n  border-radius: 6px; \n  font-size: 14px;\n  font-weight: 400;\n  transition: background-color 0.3s ease;\n  \n}\n.btn-log:hover{  \n  color: #0b76f0;\n}\n.input{\n  align-items: left;\n  margin-left: 38px;\n   color: dimgray; \n}\n.login-form{\n  margin-right: 10px;\n}\n  .image{\n    max-width: 60%;\n  }\n.for-remember{\n  color: rgb(15, 14, 14);\n}\n\n.btn-log{\n  color: #07c4f3;\n}\n.small {\n  font-size: small;\n}\n.small1 {\n  font-size: small;\n  text-align: center;\n}\n\n.custom-checkbox input[type=\"checkbox\"]:checked + .MuiSvgIcon-root {\n  background-color: #07c4f3;\n}\n\n\n.error-container {\n  text-align: center;\n  font-size: 120px;\n  font-weight: 800;\n  margin: 20px 15px;\n}\n\n.error-container > span {\n  display: inline-block;\n  line-height: 0.7;\n  position: relative;\n  color: #FFB485;\n  vertical-align: middle;\n  font-size: 80px; \n}\n.error-container > span:nth-of-type(1) {\n  color: #D1F2A5;\n  animation: colordancing 4s infinite;\n}\n.error-container > span:nth-of-type(2) {\n  color: #D1F2A5;\n  animation: colordancing1 4s infinite;\n}\n\n.error-container > span:nth-of-type(3) {\n  color: #F56991;\n  animation: colordancing2 4s infinite;\n}\n\n.error-container > span.zero:before {\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.screen-reader-text {\n  position: absolute;\n  top: -9999em;\n  left: -9999em;\n}\n\n\n@keyframes shadowsdancing {\n  0% {\n    box-shadow: inset 30px 0 0 rgba(209, 242, 165, 0.4),\n\t\t\t\tinset 0 30px 0 rgba(239, 250, 180, 0.4),\n\t\t\t\tinset -30px 0 0 rgba(255, 196, 140, 0.4),\t\n\t\t\t\tinset 0 -30px 0 rgba(245, 105, 145, 0.4);\n  }\n  25% {\n    box-shadow: inset 30px 0 0 rgba(245, 105, 145, 0.4),\n\t\t\t\tinset 0 30px 0 rgba(209, 242, 165, 0.4),\n\t\t\t\tinset -30px 0 0 rgba(239, 250, 180, 0.4),\t\n\t\t\t\tinset 0 -30px 0 rgba(255, 196, 140, 0.4);\n  }\n  50% {\n     box-shadow: inset 30px 0 0 rgba(255, 196, 140, 0.4),\n\t\t\t\tinset 0 30px 0 rgba(245, 105, 145, 0.4),\n\t\t\t\tinset -30px 0 0 rgba(209, 242, 165, 0.4),\t\n\t\t\t\tinset 0 -30px 0 rgba(239, 250, 180, 0.4);\n  }\n  75% {\n   box-shadow: inset 30px 0 0 rgba(239, 250, 180, 0.4),\n\t\t\t\tinset 0 30px 0 rgba(255, 196, 140, 0.4),\n\t\t\t\tinset -30px 0 0 rgba(245, 105, 145, 0.4),\t\n\t\t\t\tinset 0 -30px 0 rgba(209, 242, 165, 0.4);\n  }\n  100% {\n    box-shadow: inset 30px 0 0 rgba(209, 242, 165, 0.4),\n\t\t\t\tinset 0 30px 0 rgba(239, 250, 180, 0.4),\n\t\t\t\tinset -30px 0 0 rgba(255, 196, 140, 0.4),\t\n\t\t\t\tinset 0 -30px 0 rgba(245, 105, 145, 0.4);\n  }\n}\n@keyframes colordancing {\n  0% {\n    color: #0cd7e6;\n  }\n  25% {\n    color: #F56991;\n  }\n  50% {\n    color: #FFC48C;\n  }\n  75% {\n    color: #EFFAB4;\n  }\n  100% {\n    color: #09e3f3;\n  }\n}\n@keyframes colordancing2 {\n  0% {\n    color: #FFC48C;\n  }\n  25% {\n    color: #EFFAB4;\n  }\n  50% {\n    color: #09dfee;\n  }\n  75% {\n    color: #F56991;\n  }\n  100% {\n    color: #FFC48C;\n  }\n}\n@keyframes colordancing1 {\n  0% {\n    color: #FFC48C;\n  }\n  25% {\n    color: #EFFAB4;\n  }\n  50% {\n    color: #09dfee;\n  }\n  75% {\n    color: #F56991;\n  }\n  100% {\n    color: #FFC48C;\n  }\n}\n\n* {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\nbody {\n  background-color: #416475;\n  margin-bottom: 50px;\n}\nhtml, button, input, select, textarea {\n    color: #6c787e;\n}\nh1 {\n  text-align: center;\n  margin: 30px 15px;\n}\n.zoom-area { \n  max-width: 490px;\n  margin: 30px auto 30px;\n  font-size: 19px;\n  text-align: center;\n}\n.link-container {\n  text-align: center;\n}\na.more-link {\n  text-transform: uppercase;\n  font-size: 13px;\n    background-color: #92a4ad;\n    padding: 10px 15px;\n    border-radius: 0;\n    color: #416475;\n    display: inline-block;\n    margin-right: 5px;\n    margin-bottom: 5px;\n    line-height: 1.5;\n    text-decoration: none;\n  margin-top: 50px;\n  letter-spacing: 1px;\n}\n\n@media only screen and (max-width: 1024px) {\n  \n  .error-container{\n    display: block;\n  }\n  .my-grid-class{\n    display: block;\n    position: static;\n    \n  }\n}\n@media only screen and (min-width: 1025px) {\n  \n  .error-container {\n    display: none;\n  }\n  .Desktop-feature{\n    display: none;\n  }\n}\n*:not(input) {\n  user-select: none;\n}\n\n.my-Box2 {\n  border: none;\n  padding: 5px;\n  margin-bottom: 200%;\n  font: 24px/36px sans-serif;\n  overflow-y: scroll;\n\n  /* Scrollbar styles */\n  scrollbar-width: thin;\n  scrollbar-color: rgb(49, 49, 48) rgb(79, 80, 78);\n\n  /* Track styles */\n  &::-webkit-scrollbar {\n    width: 10px;\n    height: 2px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: rgb(235, 238, 231);\n  }\n\n  /* Thumb styles */\n  &::-webkit-scrollbar-thumb {\n    background-color: rgb(134, 134, 128);\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #bdc5bd;\n  }\n}.pagination li button {\n  color: #0985dd;\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
